import styles from "./PageWrapper.module.css";

const PageWrapper = ({ className, children }) => {
      return (
            <div className={styles.pageWrapper + " " + className}>
                  {children}
            </div>
      );
};

export default PageWrapper;
